export default __webpack_public_path__ + "static/SRUS CS30 - Product Specifications & Technical Data-8ecdfcb6919d8d652cf4803bd3745782.pdf";